import { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import { Sidebar } from '../Layout/Sidebar';

const Brand = () => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 25;
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = data.filter(e => e.title.toLowerCase().includes(query.toLowerCase())).slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage)

  const deleteItem = async (id: number) => {
    if (confirm('آیا مطمئن هستید؟')) {
      dispatch(setLoading(true));

      const res = await restApi(process.env.REACT_APP_BASE_URL + '/admin/brand/' + id, true).delete({});

      if (res.code == 204) {
        Swal.fire({
          title: 'موفق',
          text: 'برند با موفقیت حذف شد',
          icon: 'success',
          confirmButtonText: 'متوجه شدم'
        });
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: res?.data,
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        });
      }
      dispatch(setLoading(false));
      await fetchData();
    }
  };

  const syncToWooCommerce = async () => {
    const confirmSync = await Swal.fire({
      title: 'همگام‌سازی برندها',
      text: 'آیا مطمئن هستید که می‌خواهید برندها را با ورد پرس همگام‌سازی کنید؟',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'بله، همگام‌سازی کن',
      cancelButtonText: 'انصراف'
    });

    if (confirmSync.isConfirmed) {
      dispatch(setLoading(true));

      try {
        const syncRes = await restApi(process.env.REACT_APP_BASE_URL + '/admin/brand/sync-to-woocommerce', true).post({});

        dispatch(setLoading(false));

        if (syncRes.code === 200) {
          const { created, updated, skipped, errors } = syncRes.data;
          Swal.fire({
            title: 'همگام‌سازی برندها موفق',
            html: `
            <p>ایجاد شده: ${created}</p>
            <p>به‌روزرسانی شده: ${updated}</p>
            <p>رد شده: ${skipped}</p>
            <p>خطاها: ${errors.length}</p>
          `,
            icon: 'success',
            confirmButtonText: 'متوجه شدم'
          });
        } else {
          Swal.fire({
            title: 'خطا در همگام‌سازی',
            text: syncRes.data?.error || syncRes.data || 'خطایی رخ داده است',
            icon: 'error',
            confirmButtonText: 'متوجه شدم'
          });
        }
      } catch (error) {
        dispatch(setLoading(false));
        Swal.fire({
          title: 'خطا',
          text: 'خطایی رخ داده است',
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        });
      }
    }
  };

  const list = () => {
    const rows = [];

    currentItems.map((brand: any, index) => {
      rows.push(
        <tr
          className={`dashTr2 ${index % 2 === 0 ? 'table-row-even' : 'table-row-odd'}`}
          key={`brand-${brand.id}-${index}`}
        >
          <td className="svgContainer">
            <i className="eye"></i>
            <i className="trash clickable" onClick={() => deleteItem(brand.id)}></i>
            <i className="edit clickable" onClick={() => navigate('/brand/edit/' + brand.id)}></i>
          </td>
          <td className="">{brand.createdAt}</td>
          <td className="">{brand.description}</td>
          <td className="">{brand.slug}</td>
          <td className="">{brand.title}</td>
          <td>{index + 1}</td>
        </tr>
      );
    });

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.brand.index).get();

    if (res.code == 200) {
      setData(res.data);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <body className="dashboardBody">
      <Sidebar/>
      <main className="dashBoardMain">
        <h1 className="dashBoardTitle">لیست برندها </h1>
        <div className="searchContainer">
          <div className="keepRight svgContainer">
            <span className="dashboardHeader clickable" onClick={() => navigate('/brand/add')}>
              <p>افزودن برند جدید</p>
              <i className="addPlus"></i>
            </span>
            <span className="dashboardHeader clickable" onClick={syncToWooCommerce}>
              <p>همگام‌سازی با ورد پرس</p>
              <i className="addPlus"></i>
            </span>
          </div>
          <div className="dashboardseaechBox">
            <i className="dashMagnifierIcon"></i>
            <input className="dashSearchInput" placeholder="جستجو" onChange={(input: any) => setQuery(input.target.value)}></input>
          </div>
        </div>
        <table className="alternating-table listTable">
          <thead>
          <tr className="dashTr1 firstTR">
            <th>عملیات</th>
            <th>تاریخ ساخت</th>
            <th>توضیحات</th>
            <th>اسلاگ</th>
            <th>عنوان</th>
            <th>ردیف</th>
          </tr>
          </thead>
          <tbody>
          {list()}
          </tbody>
        </table>
        <ReactPaginate
          breakLabel="..."
          nextLabel="بعدی >"
          onPageChange={(event) => setItemOffset((event.selected * itemsPerPage) % data.length)}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< قبلی"
          renderOnZeroPageCount={null}
          className="pagination"
          pageClassName="paginationBreak"
          previousClassName="paginationBreak"
          nextClassName="paginationBreak"
          activeClassName="paginationActive"
        />
      </main>
      </body>
    </>
  );
};
export default Brand;